import Container from "@mui/material/Container";
import { useEffect } from "react";

function PrivacyPolicy() {
    useEffect(() => {
        const mainContainer = document.getElementsByClassName("main-container")[0]
        
        mainContainer.scrollIntoView(true)
    })

    return (
        <Container maxWidth="xs" className="main-container">
            <h1>Charte Données Personnelles et Traceurs&nbsp;</h1>

            <p>Bienvenue sur le site internet https://machargerapide.totalenergies.fr</p>

            <p>La Charte Données Personnelles et Cookies (ci-après "Charte") vise à vous informer des droits et libertés que vous pouvez faire valoir à l'égard de notre utilisation de vos données personnelles et décrit les mesures que nous mettons en œuvre afin de les protéger.&nbsp;&nbsp;</p><p>TotalEnergies SE est le « responsable du traitement » de données personnelles relatives à la gestion du site internet https://machargerapide.totalenergies.fr. Ces traitements sont mis en œuvre conformément au droit applicable.&nbsp;</p>

            <h2>1. Finalité, fondement du traitement des données collectées et durée de conservation&nbsp;</h2>

            <p>En utilisant le site internet https://machargerapide.totalenergies.fr, vos données personnelles sont susceptibles de faire l’objet des traitements suivants :</p>
            <table >


                <thead>
                    <tr>
                        <th >Finalité</th>
                        <th >Catégories de données personnelles</th>
                        <th >Base juridique</th>
                        <th >Durée de conservation</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td >Statistique</td>
                        <td >Données de connexion (ID utilisateur unique)</td>
                        <td ><p>Les informations sont nécessaires pour nous permettre de remplir nos obligations légales. A défaut, TotalEnergies SE, ne pourra pas traiter votre demande.</p>
                        </td>
                        <td >24 mois</td>
                    </tr>
                </tbody>
            </table>
            <h2>2. Destinataires des données&nbsp;</h2>

            <p>Afin d'effectuer les traitements prévus par la présente Charte, vos données personnelles sont susceptibles d’être communiquées à certains départements du responsable du traitement ou des sociétés de la compagnie TotalEnergies&nbsp;ainsi qu’à certains prestataires : TotalEnergies SE</p>
            <h2>3. <span><span><span><strong><span><span>Sécurité et confidentialité de vos données</span></span></strong></span></span></span></h2>

            <p><span><span><span><span><span><span>Le responsable du traitement met en œuvre des mesures appropriées pour préserver la sécurité et la confidentialité de vos données personnelles et, notamment, pour empêcher qu’elles soient déformées, endommagées, ou que des tiers non autorisés y aient accès.&nbsp;</span></span></span></span></span></span></p>

            <h2>4. <span><span><span><strong><span><span>Gestion des cookies et autres traceurs &nbsp;</span></span></strong></span></span></span></h2>

            <p><span><span><span><span><span><span>Un cookie est un fichier qui permet d’enregistrer des informations relatives à votre navigation et de la faciliter sur </span></span></span></span></span></span><span><span><span><span><span>le site internet https://machargerapide.totalenergies.fr.</span></span></span></span></span></p>

            <p><span><span><span><span><span><span>Les cookies sont des fichiers texte qui sont déposés sur votre terminal. Ils permettent d’accéder à différentes informations vous concernant. Certains d’entre eux appartiennent à l’éditeur du site / de l’application (First party), d’autres à des opérateurs tiers (Third party).  &nbsp;</span></span></span></span></span></span></p>

            <p><span><span><span><span><span><span>Le tableau ci-dessous donne une vue détaillée sur chaque cookie/traceur. &nbsp;</span></span></span></span></span></span></p>

            <p><span><span><span><span><span><span>Nous activons uniquement des cookies et traceurs de type technique qui sont indispensables à la fourniture du service que vous demandez sur </span></span></span></span></span></span><span><span><span><span><span>le site internet https://machargerapide.totalenergies.fr.</span></span></span></span></span><br />
                &nbsp;</p>

            <p><strong>Comment retirer votre consentement ? &nbsp;</strong></p>

            <p>Lors de votre première connexion sur le site internet https://machargerapide.totalenergies.fr, vous donnez, ou non, votre consentement à l’utilisation de cookies et/ou procédez à un paramétrage. Si par la suite, vous souhaitez revenir sur vos choix, vous pouvez gérer vos cookies en vous rendant dans la rubrique en bas de page de notre site ou application ou via un bouton de rappel nommé “cookies”.&nbsp;</p>

            <p>Pour supprimer les cookies déjà installés, merci de vous référer au mode opératoire fourni par votre système d’exploitation (Windows, OS X, etc.).&nbsp;&nbsp;</p>

            <p>&nbsp;</p>

            <h2>5. <strong>Vos droits / Contact&nbsp;</strong></h2>

            <p>Conformément à la réglementation en vigueur, vous disposez d’un droit d’accès et de rectification de vos données et de directives post-mortem. Pour les traitements fondés sur l’obligation légale, vous pouvez également demander la limitation du traitement.</p>
            <p>Pour exercer vos droits et nous interroger sur le traitement de vos données personnelles, vous pouvez vous adresser à TotalEnergies Marketing France res-mkt-cap@totalenergies.com  <br>
            </br>
                Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à l’autorité de contrôle compétente. </p>

        </Container>
    )
}

export default PrivacyPolicy;